var _a;
import keys from "./keys";
var translate = (_a = {},
    _a[keys.LNG_af] = "Afrikaans",
    _a[keys.LNG_sq] = "Albanian",
    _a[keys.LNG_ar] = "Arabic",
    _a[keys.LNG_az] = "Azerbaijani",
    _a[keys.LNG_bn] = "Bengali",
    _a[keys.LNG_bg] = "Bulgarian",
    _a[keys.LNG_ca] = "Catalan",
    _a[keys.LNG_zh_CN] = "Chinese (CHN)",
    _a[keys.LNG_zh_HK] = "Chinese (HKG)",
    _a[keys.LNG_zh_TW] = "Chinese (TAI)",
    _a[keys.LNG_hr] = "Croatian",
    _a[keys.LNG_cs] = "Czech",
    _a[keys.LNG_da] = "Danish",
    _a[keys.LNG_nl] = "Dutch",
    _a[keys.LNG_en] = "English",
    _a[keys.LNG_en_GB] = "English (UK)",
    _a[keys.LNG_en_US] = "English (US)",
    _a[keys.LNG_et] = "Estonian",
    _a[keys.LNG_fil] = "Filipino",
    _a[keys.LNG_fi] = "Finnish",
    _a[keys.LNG_fr] = "French",
    _a[keys.LNG_de] = "German",
    _a[keys.LNG_el] = "Greek",
    _a[keys.LNG_gu] = "Gujarati",
    _a[keys.LNG_ha] = "Hausa",
    _a[keys.LNG_he] = "Hebrew",
    _a[keys.LNG_hi] = "Hindi",
    _a[keys.LNG_hu] = "Hungarian",
    _a[keys.LNG_id] = "Indonesian",
    _a[keys.LNG_ga] = "Irish",
    _a[keys.LNG_it] = "Italian",
    _a[keys.LNG_ja] = "Japanese",
    _a[keys.LNG_kn] = "Kannada",
    _a[keys.LNG_kk] = "Kazakh",
    _a[keys.LNG_ko] = "Korean",
    _a[keys.LNG_lo] = "Lao",
    _a[keys.LNG_lv] = "Latvian",
    _a[keys.LNG_lt] = "Lithuanian",
    _a[keys.LNG_mk] = "Macedonian",
    _a[keys.LNG_ms] = "Malay",
    _a[keys.LNG_ml] = "Malayalam",
    _a[keys.LNG_mr] = "Marathi",
    _a[keys.LNG_nb] = "Norwegian",
    _a[keys.LNG_fa] = "Persian",
    _a[keys.LNG_pl] = "Polish",
    _a[keys.LNG_pt_BR] = "Portuguese (BR)",
    _a[keys.LNG_pt_PT] = "Portuguese (POR)",
    _a[keys.LNG_pa] = "Punjabi",
    _a[keys.LNG_ro] = "Romanian",
    _a[keys.LNG_ru] = "Russian",
    _a[keys.LNG_sr] = "Serbian",
    _a[keys.LNG_sk] = "Slovak",
    _a[keys.LNG_sl] = "Slovenian",
    _a[keys.LNG_es] = "Spanish",
    _a[keys.LNG_es_AR] = "Spanish (ARG)",
    _a[keys.LNG_es_ES] = "Spanish (SPA)",
    _a[keys.LNG_es_MX] = "Spanish (MEX)",
    _a[keys.LNG_sw] = "Swahili",
    _a[keys.LNG_sv] = "Swedish",
    _a[keys.LNG_ta] = "Tamil",
    _a[keys.LNG_te] = "Telugu",
    _a[keys.LNG_th] = "Thai",
    _a[keys.LNG_tr] = "Turkish",
    _a[keys.LNG_uk] = "Ukrainian",
    _a[keys.LNG_ur] = "Urdu",
    _a[keys.LNG_uz] = "Uzbek",
    _a[keys.LNG_vi] = "Vietnamese",
    _a[keys.LNG_zu] = "Zulu",
    _a);
export default translate;
//# sourceMappingURL=data:application/json;base64,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